import React from 'react';
import intl from "react-intl-universal";
import {observer} from "mobx-react-lite";


import {CheckoutPeriod, PaymentGateway} from "../../../types";

import {PaddleLikeSelect} from "../../../../ui/components/form/PaddleLikeSelect";

import './SelectPeriod.css';


export interface SelectPeriodProps {
    paymentGateway: PaymentGateway;
}


export const SelectPeriod = observer((
    {
        paymentGateway,
    }: SelectPeriodProps
) => {
    const onSelect = (value: CheckoutPeriod) => {
        paymentGateway.setCheckoutInput({
            period: value,
        })
    }

    return (
        <PaddleLikeSelect
            value={paymentGateway.checkoutInput.period}
            onChange={onSelect}
            options={[
                {
                    value: 'yearly',
                    label: `${intl.get('checkout.yearly').d('Annually')} (${intl.get('checkout.yearly_save', {N: 17}).d('save {N}%')})`,
                },
                {
                    value: 'monthly',
                    label: intl.get('checkout.monthly').d('Monthly'),
                },
            ] as const}
        />
    );
});
